import {
  VISIT_PRE_SALE_STATUS_BADGE_COLOR,
  VISIT_PRE_SALE_STATUS_NAMES,
  VisitPreSaleState,
} from '../../../constants/visitsConstants';
import {
  CalendarVisitInvestorEvents,
  ProjectVisitList,
} from '../models/visitsInvestorModel';

export const pickCalendarEventColor = (status: string) => {
  switch (status) {
    case VisitPreSaleState.DELETED:
      return 'bg-red text-white';
    case VisitPreSaleState.DONE:
      return 'bg-success text-white';
    case VisitPreSaleState.RESCHEDULED:
      return 'bg-info text-white';
    case VisitPreSaleState.PENDING_APPROVAL:
      return 'bg-warning text-white';
    default:
      return 'bg-secondary';
  }
};

export const buildCalendarVisitInvestorEvent = (
  projectVisit: ProjectVisitList,
  dateTime: any,
): CalendarVisitInvestorEvents => {
  const { year, month, day, hours, minutes } = dateTime;

  const landlordInfo = projectVisit.landlordInfo;
  const guestInfo = projectVisit.guestInfo;
  const investorName = landlordInfo
    ? landlordInfo.name
    : guestInfo
      ? guestInfo.name
      : 'NA';

  return {
    id: projectVisit.id,
    title: `Asesoría ${investorName}`,
    start: new Date(year, month - 1, day, hours, minutes),
    allDay: false,
    className: pickCalendarEventColor(projectVisit.status),
    landlordInfo: projectVisit.landlordInfo,
    guestInfo: projectVisit.guestInfo,
    status: projectVisit.status,
    proper_id: projectVisit.proper_id,
    sdr_id: projectVisit.sdr_id,
  };
};

export const buildCalendarVisitInvestorData = (visits: ProjectVisitList[]) => {
  const visitsAdapted: CalendarVisitInvestorEvents[] = visits.map((el) => {
    const { year, month, day, hours, minutes } = el.visitDateTime;
    return buildCalendarVisitInvestorEvent(el, {
      year,
      month,
      day,
      hours,
      minutes,
    });
  });
  return visitsAdapted;
};

export const getVisitPreSaleStatusAdapter = (status: string) => {
  return VISIT_PRE_SALE_STATUS_NAMES.hasOwnProperty(status)
    ? VISIT_PRE_SALE_STATUS_NAMES[status]
    : 'NA';
};

export const getBadgeColorVisitPreSaleStatusAdapter = (
  status: string,
): string => {
  return VISIT_PRE_SALE_STATUS_BADGE_COLOR.hasOwnProperty(status)
    ? VISIT_PRE_SALE_STATUS_BADGE_COLOR[status]
    : 'default';
};
